const generateQueryParams = (obj: any) => {
    if (!obj || typeof obj !== 'object' || (obj && Object.keys(obj).length === 0)) {
        return '';
    }
    return Object.keys(obj)
        .filter((key) => obj[key])
        .map(key => `${key}=${obj[key]}`)
        .join('&');
}

export default generateQueryParams;

export const createQueryParams = (fields: Record<string, any>): string => {
    const params = new URLSearchParams();

    Object.entries(fields || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            params.append(key, String(value));
        }
    });

    return params.toString(); // returns: key=value&key2=value2
};
